import type { Logger } from '../types/logger';

export async function waitForFileCompletion(
  logger: Logger,
  filePath: string,
  getCurrentFileSize: () => number,
  sleepOneSecond: () => Promise<void>,
  minSecondsToDecideGrowth: number = 5,
  maxSecondsToWait: number = 30
): Promise<boolean> {
  let totalSecondsSpent = 0;
  let secondsSinceLastGrowth = 0;
  let lastSize;
  let lastError;
  while (totalSecondsSpent < maxSecondsToWait) {
    let currentSize;
    try {
      currentSize = getCurrentFileSize();
      lastError = undefined;
    } catch (error) {
      // could be that file does not exist yet. just remember the last error to print before we quit.
      lastError = error;
    }

    if (currentSize !== undefined && currentSize !== null && currentSize === lastSize) {
      secondsSinceLastGrowth++;
    } else {
      lastSize = currentSize;
      secondsSinceLastGrowth = 0;
    }

    if (secondsSinceLastGrowth >= minSecondsToDecideGrowth) {
      if (lastError) {
        logger.info(`isGrowing: ${filePath} didn't grow for last ${secondsSinceLastGrowth}s. deciding completion. lastError: ${lastError}`);
      }
      return true;
    }

    await sleepOneSecond();
    totalSecondsSpent++;
  }

  if (lastError) {
    logger.info(`isGrowing: ${filePath} ${(lastSize === undefined || isNaN(lastSize)) ? 'does not exist' : 'still growing'} after checking for ${totalSecondsSpent}s. giving up. ${lastError}`);
  }
  return false;
}
